__turbopack_context__.v({
  "containerDropdown": "BoatsMenu-module-scss-module__eVFoea__containerDropdown",
  "footer": "BoatsMenu-module-scss-module__eVFoea__footer",
  "rootClassName": "BoatsMenu-module-scss-module__eVFoea__rootClassName",
  "sectionTitle": "BoatsMenu-module-scss-module__eVFoea__sectionTitle",
  "viewAllLink": "BoatsMenu-module-scss-module__eVFoea__viewAllLink",
});
